import { SegmentCardEvent } from '../../../../../../../../middlewares/segment/trackEntities/cardEvents';
import {Dispatch, ThunkAction} from '../../../../../../../../types/actions';
import {segmentTrackAction} from '../../../../../../../../middlewares/segment';

export const onMore = (
): ThunkAction => {
    return (dispatch: Dispatch) => {
        dispatch(segmentTrackAction(SegmentCardEvent.MORE_ACTIONS_BUTTON_CLICKED));
    };
};
